var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filter.includes(_vm.consumo))?_c('span',{staticClass:"produto-restricao produto-consumo",class:{'produto-consumo-sacola': _vm.variant === 'sacola'}},[_vm._v(" "+_vm._s(_vm._f("tipo_consumo")(_vm.consumo))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }